import axios from "axios";

export async function getCollaboratorsCard({ category }) {
    
    try {
        const result = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/public/collaboratorsCard`, {
            params: { category },
            withCredentials: true,
            validateStatus: () => true
        });
        return result.data;
    } catch (_) {
        return {success: false, data: [], error: {code: "SERVER_ERROR", message: "Impossible de contacter le serveur"} };
    }
}

export async function getCollaboratorsMap() {
    try {
        const result = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/public/collaboratorsMap`, {
            withCredentials: true,
            validateStatus: () => true,
        });
        return result.data;
    } catch (_) {
        return {success: false, data: [], error: {code: "SERVER_ERROR", message: "Impossible de contacter le serveur"} };
    }
}
